var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('footer',[_c('p',[_vm._v("© 2021 Kurlon Enterprise Limited")])])}]

export { render, staticRenderFns }